import { useIntl } from 'react-intl';
import useAnalytics from '../../hooks/useAnalytics';

interface ISelectRidesModalProps {
  rideId: string | null;
  startDateAndAddress: string;
  lastDateAndAddress: string;
  endDateAndAddress: string;
  handleModal: () => void;
  origStatus: string;
}

export default function RideStartAndEnd(props: ISelectRidesModalProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const { trackEvent } = useAnalytics();

  const handleOnClick = () => {
    trackEvent(['Graph page', 'click', 'Choose ride button']);
    props.handleModal();
  };

  return (
    <div className="row">
      <div className="col-12 col-sm-6 col-lg-10 my-3 my-lg-0">
        <div>
          <span className="e-dot e-dot--sm e-dot--green" />{' '}
          <strong>{props.startDateAndAddress}</strong>
        </div>
        <div className="mt-1">
          {props.endDateAndAddress && (
            <div>
              <span className="e-dot e-dot--sm e-dot--red" />{' '}
              <strong>{props.endDateAndAddress}</strong>
            </div>
          )}
          {!props.endDateAndAddress && (props.origStatus === 'STOP' || props.rideId) && (
            <div>
              <span className="e-dot e-dot--sm e-dot--red" />{' '}
              <strong>{props.lastDateAndAddress}</strong>
            </div>
          )}
        </div>
      </div>
      <div className="col-12 col-sm-6 col-lg-2 my-3 my-lg-0">
        <button
          style={{
            float: 'right',
            cursor: 'pointer',
          }}
          type="button"
          className="e-button e-button--gray mb-2"
          onClick={handleOnClick}
        >
          {f({
            id: 'graph.velocity.choose',
          })}
        </button>
      </div>
    </div>
  );
}
